import { Button } from "../../components/button/button";
import { Header } from "../../components/header/header";
import { Spring } from "../../components/spring/spring";
import { useAnimatedNavigate } from "../../hooks/useAnimatedNavigate";
import { Policy } from "./policy";
import AdminAPI from "../../api/AdminAPI";

import styles from "./policy.module.css";


export const AdminPolicyPage = () => {
    const navigate = useAnimatedNavigate();

    const onConfirm = () => {
        AdminAPI
            .updateDocsAgreement()
            .catch(console.error)
            .then(() => navigate("/admin"));
    }

    return (
        <div className="page_container">
            <div className="page_content">
                <Header title="Пользовательское соглашение" withData={false} />

                <Policy />

                <Spring />

                <Button
                    className={styles.button}
                    text="Я согласен с политикой"
                    onClick={onConfirm}
                />
            </div>
        </div>
    )
}